import { SET_OPERATING } from "./types";

export const SetOperatingStatus = (status) => {
  // storeCart();
  return {
    type: SET_OPERATING,
    payload: status,
  };
};
